import { ISVGIconProps } from '@cian/ui-kit-design-tokens/icons';
import { FC } from 'react';
import styles from './HighwayItem.css';
import { UIText2 } from '@cian/ui-kit';

interface IHighwayItemProps {
  icon: FC<ISVGIconProps>;
  text: string;
}

export const HighwayItem: FC<IHighwayItemProps> = ({ icon: Icon, text }) => {
  return (
    <div className={styles['highway-item']}>
      <Icon />
      <UIText2>{text}</UIText2>
    </div>
  );
};
